"use client";

import EngineDateTable from "@/components/vrat/EngineDateTable";
import type { CalendarSankashtiItem } from "@/lib/api/calendar";

export interface SankashtiYearData {
  year: number;
  sankashtis: CalendarSankashtiItem[];
}

export default function SankashtiDates({ years }: { years: SankashtiYearData[] }) {
  return (
    <EngineDateTable
      years={years.map(({ year, sankashtis }) => ({ year, entries: sankashtis }))}
      tabLabel="Sankashti"
      itemHeader="Sankashti Chaturthi"
      detailHeader="Hindu month"
      emptyMessage="Sankashti Chaturthi dates are computed live from the Vedic engine. The schedule could not be loaded right now — please refresh in a moment to see every Chaturthi date with its lunar month."
      footer="All Sankashti Chaturthi dates are computed from real planetary positions using the Swiss Ephemeris engine with Lahiri Ayanamsa — the Chaturthi tithi boundary, not a fixed calendar."
    />
  );
}
